import { render, staticRenderFns } from "./BaseEditableField.vue?vue&type=template&id=d35f04e6&"
import script from "./BaseEditableField.vue?vue&type=script&lang=js&"
export * from "./BaseEditableField.vue?vue&type=script&lang=js&"
import style0 from "./BaseEditableField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BaseEditableField.vue"
export default component.exports